/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-25 17:20:03
 * @FilePath: /code/mall-fe/src/comps/HomeHireBanner.cscec3b.tsx
 * @Description:商城首页招租广告栏组件
 *
 */
/* eslint-disable @next/next/no-img-element */
import React, { useContext, useState, useRef, useEffect } from 'react';
import { Modal, Button, Tooltip } from 'antd';
import { useRouter } from 'next/router';
import { useBannerImage } from 'hooks/useImage';
import { DeviceContext, UserContext } from 'libs/contexts';
import { getWofengService } from 'api/common';
import { getUserDetail } from 'api/user';
import { getWofengServiceParams } from 'libs/utils';
import HireBannerBgImg from 'images/cscec3b/hireAd/hire-banner-bg';
import HireBannerBgImgW from 'images/cscec3b/hireAd/hire-banner-bgw';
import ContactUsImg from 'images/cscec3b/hireAd/contact-us';
import ContactUsImgW from 'images/cscec3b/hireAd/contact-usw';
import HomeTitle from '@/comps/HomeTitle'
import { webps } from 'libs/imgs';
webps[HireBannerBgImg] = HireBannerBgImgW;
webps[ContactUsImg] = ContactUsImgW;

type BannerProps = {
  banners: BannerInfo[];
};
let timer = null;
export default function HomeHireBanner({ banners }: BannerProps) {
  const bannerList = banners.slice(0, 8);
  const renderList =
    bannerList.length > 4
      ? [bannerList[bannerList.length - 1], ...bannerList, ...bannerList]
      : bannerList;
  const userInfo = useContext(UserContext);
  const [visible, setVisible] = useState<boolean>(false);
  const router = useRouter();
  const { buildImgSrc } = useContext(DeviceContext);
  // 是否加载完成，图片webp优化，失败的回调
  const { renderBannerImg, buildBannerImgSrc, handleErrorImg } = useBannerImage();

  // 客服咨询
  const toService = async () => {
    if (userInfo?.name) {
      const { data } = await getUserDetail();
      const params = await getWofengServiceParams(data);
      const res = await getWofengService(params);
      if (res.code === 200) {
        window.open(res.data?.url, '_blank');
      }
      return;
    } else {
      setVisible(true);
    }
  };
  // 去登录
  const toLogin = () => {
    setVisible(false);
    const retUrl = `${location.protocol}//${location.host}${router.pathname}`;
    router.push(`/sso/xlogin?return_url=${encodeURIComponent(retUrl)}`);
  };
  // 游客-客服咨询
  const visitorToService = async () => {
    const params = await getWofengServiceParams();
    const res = await getWofengService(params);
    if (res.code === 200) {
      setVisible(false);
      window.open(res.data?.url, '_blank');
    }
  };
  const onCancel = () => {
    setVisible(false);
  };

  const moveWarpperRef = useRef(null);
  let currentIndex = 1;
  // 下一个创新项的函数
  const next = () => {
    currentIndex += 1;
    moveWarpperRef.current.style.transition = `transform 450ms ease 0s`;
    moveWarpperRef.current.style.transform = `translateX(-${currentIndex * 300}px)`;
    // 如果滑动到最后一页后，重置回第一页
    if (currentIndex === bannerList.length + 1) {
      currentIndex = 1;
      // 在 300 毫秒后，取消移动动画，将滑块位置重置回第一页
      setTimeout(() => {
        moveWarpperRef.current.style.transition = `transform 0ms ease 0s`;
        moveWarpperRef.current.style.transform = `translateX(-${currentIndex * 300}px)`;
      }, 300);
    }
  };
  
  const mouseenter = () => {
    clearInterval(timer);
  };
  const mouseleave = () => {
    if (bannerList.length > 4) {
      startMove();
    }
  };
  const startMove = () => {
    clearInterval(timer);
    timer = setInterval(() => {
      next();
    }, 3000);
  };
  useEffect(() => {
    if (bannerList.length > 4) {
      startMove();
    }
    return () => {
      clearInterval(timer);
    };
  }, []);
  return (
    <div className="hire-banner-container">
      <HomeTitle title={'优质推荐'} />
      <div className="banner-bg">
        <div className="animation-container">
          <div className="animation-warpper" ref={moveWarpperRef}
            onMouseEnter={mouseenter}
            onMouseLeave={mouseleave}>
            {renderList.map((item, index) => {
              const Tag = item.link ? 'a' : 'span';
              return (
                <Tooltip
                  placement="top"
                  key={index}
                  title={item.extra}
                  overlayClassName="hire-banner-tooltip"
                >
                  <Tag
                    className="banner-content"
                    key={index}
                    onClick={() => {
                      if (item.link) {
                        window.open(
                          item.link,
                          item.link ? (item.link.startsWith('/') ? '_top' : '_blank') : undefined,
                        );
                      }
                    }}
                  >
                    {renderBannerImg && (
                      <img
                        onError={handleErrorImg}
                        className="banner-img"
                        src={buildBannerImgSrc(item.image)}
                        alt="banner"
                      />
                    )}
                  </Tag>
                </Tooltip>
              );
            })}
          </div>
        </div>
      </div>
      {/* <i className="right-contact-us" onClick={toService} /> */}
      <Modal
        visible={visible}
        title="提示"
        onCancel={onCancel}
        footer={[
          <Button key={'visitor'} onClick={visitorToService}>
            访客咨询
          </Button>,
          <Button key={'login'} onClick={toLogin} type="primary">
            去登录
          </Button>,
        ]}
      >
        <span>您当前尚未登录，请先登录或以访客身份联系客服。</span>
      </Modal>
      <style jsx>{`
        .hire-banner-container {
          width: 1200px;
          margin: 45px auto;
          // padding: 20px 20px 20px 0;
          box-sizing: border-box;
          position: relative;
        }
        .banner-bg {
          width: 100%;
          height: 135px;
          // background-image: url(${buildImgSrc(HireBannerBgImg)});
          // background-size: 100% 100%;
          // background-repeat: no-repeat;
          // background-position: center;
          // padding: 8px 18px 8px 130px;
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
        }
        .banner-content {
          display: block;
          width: 288px;
          height: 100%;
          margin-right: 16px;
          box-sizing: border-box;
        }
        .banner-content:last-child {
          margin-right: 14px;
        }
        .banner-img {
          display: inline-block;
          width: 100%;
          height: 100%;
          object-fit: fill;
          border-radius: 10px;
        }
        .right-contact-us {
          width: 66px;
          height: 135px;
          background-image: url(${buildImgSrc(ContactUsImg)});
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          position: absolute;
          top: 20px;
          right: -40px;
          cursor: pointer;
        }
        :global(.hire-banner-tooltip) {
          z-index: 9 !important;
        }
        :global(.hire-banner-tooltip .ant-tooltip-inner) {
          border-radius: 5px;
        }
        .animation-container {
          overflow: hidden;
          width: 100%;
        }
        .animation-warpper {
          width: ${300 * (bannerList.length * 2 + 1)}px;
          height: 100%;
          display: flex;
          transform: translateX(${bannerList.length > 4 ? '-300px' : '0px'});
          transition: transform 0ms ease 0s;
        }
      `}</style>
    </div>
  );
}
